/**
 * Validator.
 */
export type Validator<T> = (value: T) => ValidationError[];

/**
 * Validation error.
 */
export type ValidationError = string;

/**
 * No-op validator.
 */
export const noopValidator: Validator<unknown> = () => [];

/**
 * Combine multiple validators.
 */
export function validatorAll<T>(validators: Validator<T>[]): Validator<T> {
  return (value) => validators.flatMap((validator) => validator(value));
}
